import {
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { API_URL_UTIL, BaseComponent } from 'src/app/@core/utils';
import { getFormattedDate } from 'src/app/@core/utils/date-format.utils';
import { StatusService } from './../../@shared/services//status.service';
import * as moment from 'moment';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { takeUntil } from 'rxjs';
import {
  ApiResponse,
  PerDiemData,
  TimeCardEquipment,
  CrewDetails,
  EmployeePhaseWiseLoggedHours,
  PhaseDetailsList,
  TandMBody,
  TimecardApiResponse,
  TimeCardUpdateParams,
  WorkArray,
} from 'src/app/@shared/models';
import { EventTask } from 'src/app/@shared/models/user.modal';
import { SidebarModalService } from 'src/app/@shared/services/sidebar-modal.service';
import { TimeCardService } from '../time-card.service';
import { HttpStatus } from 'src/app/@shared/models/add-employee.modal';
import { ForemanService } from 'src/app/other shared services/foreman.service';
import { UserDataService } from 'src/app/@shared/services/user-data.service';
import { ToasterService } from 'src/app/@core/services';
import { UrlService } from 'src/app/helper/services/url.service';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { REVIEW_TABS } from 'src/app/review/constants/review.constants';

@Component({
  selector: 'app-time-card-job',
  templateUrl: './time-card-job.component.html',
  styleUrls: ['./time-card-job.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeCardJobComponent
  extends BaseComponent
  implements OnInit, OnDestroy
{
  readOnlyApp = false;
  showEquipment = false;
  selected = false;
  selectedInput = 0;
  multiMode = false;
  modalRef!: BsModalRef | undefined;
  activeInput!: string;
  userSelectedInput!: TimeCardUpdateParams;
  inputModalRef!: BsModalRef;
  toggleValue = false;
  phaseIdSingleTandM!: string;
  formSwitchState = false;
  unSavedStatus!: boolean;
  sidebarString!: string;
  sidebar!: TemplateRef<unknown>;
  @ViewChild('confirmationPopup') saveModal!: TemplateRef<unknown>;
  modalButtonName = 'Yes';
  toolTipText!: string;
  passPerDiem!: PerDiemData;
  sidebarShow!: boolean;
  logInUser!: string;
  formValidStatus = true;
  updateFormArray: Array<TimeCardUpdateParams> = [];
  _mergedArray!: any;
  _equipment!: any;
  _addEquipment!: Array<TimeCardEquipment>;
  mergedArrayEmployee!: any;
  finalEquipmentList!: any;
  employeeModalRef!: BsModalRef;
  phaseModalRef!: BsModalRef;
  equipmentModalRef!: BsModalRef;
  perDiemModalRef!: BsModalRef;
  products!: Array<object>;
  phaseDetailsArray: Array<PhaseDetailsList> = [];
  copyOfPhaseDetails: Array<PhaseDetailsList> = [];
  statuses!: [];
  crewDetails!: Array<CrewDetails>;
  userSelectedEvent!: EventTask;
  selectedDate!: Date;
  selectedJobScheduleId!: string;
  positionCode!: string;
  timecardConfig!: {
    links: { title: string; onClick: Function }[];
    enableTandM: boolean;
    enableNextBtn: boolean;
  };
  dummyComingSoonMessage = 'Coming soon';
  employeeData: Array<TimeCardUpdateParams> = [];
  equipmentData: Array<TimeCardUpdateParams> = [];
  startDate!: Date;
  endDate!: Date;
  previousUrl!: string;

  @ViewChild('addEmployeeSidebar', { read: TemplateRef })
  addEmployeeSidebar!: TemplateRef<any>;
  @ViewChild('addPhaseSidebar', { read: TemplateRef })
  addPhaseSidebar!: TemplateRef<any>;
  @ViewChild('addEquipment', { read: TemplateRef })
  addEquipment!: TemplateRef<any>;

  constructor(
    private readonly userDataService: UserDataService,
    private readonly timeCardService: TimeCardService,
    private readonly toasterService: ToasterService,
    private readonly modalService: SidebarModalService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly foremanService: ForemanService,
    private readonly statusService: StatusService,
    private readonly urlService: UrlService,
    private readonly router: Router,
    private readonly cdr: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    this.getEvent();
    this.processPositionCode();
    this.subscribeToPreviousUrl();
  }

  subscribeToPreviousUrl(): void {
    this.urlService.previousUrl$.subscribe((previousUrl: string) => {
      this.previousUrl = previousUrl;
    });
  }

  processPositionCode(): void {
    this.userDataService.userRoleDetails$.subscribe((userRole) => {
      this.positionCode = userRole;
      this.positionCode = this.constants.roles.foreman;
      switch (this.positionCode) {
        case this.constants.roles.foreman:
          this.timecardConfig = {
            links: [
              {
                title: 'Add Employee',
                onClick: () =>
                  this.saveConfirmation('Employee', this.addEmployeeSidebar),
              },
              {
                title: 'Add Phases',
                onClick: () =>
                  this.saveConfirmation('Phase', this.addPhaseSidebar),
              },
              // {
              //   title: 'Add Equipment',
              //   onClick: () => this.saveConfirmation('Equipment', this.addEquipment),
              // },
            ],
            enableTandM: true,
            enableNextBtn: true,
          };
          break;

        case this.constants.roles.ShopSupervisor:
          // this.timecardConfig = {
          //   links: [
          //     {
          //       title: 'Add Crew',
          //       onClick: () => {
          //         this.saveConfirmation('Employee', this.addEmployeeSidebar);
          //       },
          //     },
          //     {
          //       title: 'Add Phases',
          //       onClick: () => {
          //         this.saveConfirmation('Phase', this.addPhaseSidebar);
          //       },
          //     },
          //   ],
          //   enableTandM: false,
          //   enableNextBtn: false,
          // };
          break;

        case this.constants.roles.labour:
        case this.constants.roles.shopAssist:
        case this.constants.roles.mechanic:
        default:
          break;
      }
      this.cdr.detectChanges();
    });
  }

  getEvent(): void {
    this.logInUser = this.userDataService.getLoginUser();
    this.selectedJobScheduleId =
      this.activatedRoute.snapshot.queryParams.jobScheduleID;
    if (this.selectedJobScheduleId) {
      this.selectedDate = moment(
        this.activatedRoute.snapshot.queryParams.date
      ).toDate();
      this.getJobScheduleDetails(this.selectedJobScheduleId);
    }
    this.products = [{}];
  }

  getCrewPhaseDetailsByJobScheduleId(
    selectedJobScheduleId: string,
    startDate: string
  ): void {
    this.crewDetails = [];
    this.timeCardService
      .getCrewPhaseDetailsByJobScheduleId(selectedJobScheduleId, startDate)
      .pipe(takeUntil(this.destroy$))
      .subscribe((getCrewPhaseDetailsByJobScheduleId: TimecardApiResponse) => {
        this.generateTimeSheetArray(getCrewPhaseDetailsByJobScheduleId);
        this.generateEquipmentList(getCrewPhaseDetailsByJobScheduleId);
        this.crewDetails =
          getCrewPhaseDetailsByJobScheduleId.data.crewDetailsList;
        this._addEquipment =
          getCrewPhaseDetailsByJobScheduleId.data.crewDetailsList?.filter(
            (item) => item.equipmentId !== ''
          ) as Array<TimeCardEquipment>;
        this.phaseDetailsArray =
          getCrewPhaseDetailsByJobScheduleId?.data?.phaseDetailsList;
        this.copyOfPhaseDetails =
          getCrewPhaseDetailsByJobScheduleId?.data?.phaseDetailsList;
        this.cdr.detectChanges();
      });
  }

  getEmployeePhaseList(empMapValues: any): any[] {
    return empMapValues as any[];
  }

  generateTimeSheetArray(serverResponse: TimecardApiResponse): void {
    this.mergedArrayEmployee = [];
    let tableArray: any = {};
    let mergedArray: WorkArray = {};
    let phaseDetails = serverResponse.data.phaseDetailsList?.length
      ? [...serverResponse.data.phaseDetailsList]
      : [];
    let crewDetails = serverResponse.data.crewDetailsList?.length
      ? [...serverResponse.data.crewDetailsList]
      : [];
    let employeePhaseWiseLoggedHours = serverResponse.data
      .employeephasewiseloggedhours?.length
      ? [...serverResponse.data.employeephasewiseloggedhours]
      : [];
    let workerArray: Array<EmployeePhaseWiseLoggedHours> = [];
    let copyOfEmployeeDummy = { ...employeePhaseWiseLoggedHours[0] };
    copyOfEmployeeDummy.loggedHours = undefined;
    mergedArray.workerArray = [];
    for (let index = 0; index < crewDetails.length; index++) {
      if (crewDetails[index].employeeId !== 0) {
        let employeeId = crewDetails[index].employeeId as number;
        let employeeObj = crewDetails[index];
        for (let j = 0; j < phaseDetails.length; j++) {
          const isTandM = phaseDetails[j].isTANDM;
          let phase = phaseDetails[j].phaseID as string;
          const checking = this.findEmployeeName(
            employeeId,
            phase,
            employeePhaseWiseLoggedHours,
            isTandM as boolean
          );

          if (checking) {
            checking.worksFor = employeeObj.worksFor;
            workerArray.push({ ...checking });
          } else {
            let _employeeObj = copyOfEmployeeDummy;
            _employeeObj.fullName = employeeObj.fullName;
            _employeeObj.employeeId = employeeId;
            _employeeObj.category = employeeObj.category;
            _employeeObj.description = phaseDetails[j].description;
            _employeeObj.phaseId = phase;
            _employeeObj.equipmentId = '';
            _employeeObj.isTANDM = phaseDetails[j].isTANDM;
            _employeeObj.jobSchedulePhaseID =
              phaseDetails[j].jobSchedulePhaseID;
            _employeeObj.jobSchedulePhaseForTimeAndMaterialID =
              phaseDetails[j].jobSchedulePhaseForTimeAndMaterialID;
            _employeeObj.jobSchedulePhaseForTimeAndMaterialID =
              phaseDetails[j].jobSchedulePhaseForTimeAndMaterialID;
            _employeeObj.worksFor = employeeObj.worksFor;
            workerArray.push({ ..._employeeObj });
          }
        }
        mergedArray = { workerArray };
        this._mergedArray = { workerArray };
      }
    }

    for (let index = 0; index < crewDetails.length; index++) {
      let tempEmployeeId = crewDetails[index].employeeId as number;
      if (tempEmployeeId !== 0) {
        let workerArray: Array<EmployeePhaseWiseLoggedHours> = [];
        if (mergedArray.workerArray) {
          for (let j = 0; j < mergedArray.workerArray.length; j++) {
            if (
              crewDetails[index].employeeId ===
              mergedArray.workerArray[j].employeeId
            ) {
              workerArray.push({ ...mergedArray.workerArray[j] });
            }
          }
        }
        tableArray[tempEmployeeId] = workerArray;
        this.mergedArrayEmployee = tableArray;
      }
    }

    this.cdr.detectChanges();
  }

  generateEquipmentList(serverResponse: TimecardApiResponse): void {
    this.finalEquipmentList = [];
    let tableArray: any = {};
    let mergedArray: WorkArray = {};
    let phaseDetails = serverResponse.data?.phaseDetailsList?.length
      ? [...serverResponse.data.phaseDetailsList]
      : [];
    let crewDetails = serverResponse.data?.crewDetailsList?.length
      ? [...serverResponse.data.crewDetailsList]
      : [];
    let employeePhaseWiseLoggedhours = serverResponse.data
      ?.employeephasewiseloggedhours?.length
      ? [...serverResponse.data.employeephasewiseloggedhours]
      : [];
    let workerArray: Array<EmployeePhaseWiseLoggedHours> = [];
    let copyOfEmployeeDummy = { ...employeePhaseWiseLoggedhours[0] };
    copyOfEmployeeDummy.loggedHours = undefined;
    mergedArray.workerArray = [];

    for (let index = 0; index < crewDetails.length; index++) {
      if (crewDetails[index].equipmentId) {
        let equipmentId = crewDetails[index].equipmentId as string;
        let employeeObj = crewDetails[index];
        for (let j = 0; j < phaseDetails.length; j++) {
          let phase = phaseDetails[j].phaseID as string;
          const isTANDM = phaseDetails[j]?.isTANDM;
          const checking = this.findEquipmentName(
            equipmentId,
            phase,
            employeePhaseWiseLoggedhours,
            isTANDM as boolean
          );

          if (checking) {
            checking.worksFor = employeeObj.equipmentCompany;
            workerArray.push({ ...checking });
          } else {
            let _employeeObj = copyOfEmployeeDummy;
            _employeeObj.employeeId = 0;
            _employeeObj.fullName = employeeObj.fullName;
            _employeeObj.equipmentId = equipmentId;
            _employeeObj.category = employeeObj.category;
            _employeeObj.description = phaseDetails[j].description;
            _employeeObj.phaseId = phase;
            _employeeObj.isTANDM = phaseDetails[j].isTANDM;
            _employeeObj.jobSchedulePhaseID =
              phaseDetails[j].jobSchedulePhaseID;
            _employeeObj.jobSchedulePhaseForTimeAndMaterialID =
              phaseDetails[j].jobSchedulePhaseForTimeAndMaterialID;
            _employeeObj.jobSchedulePhaseForTimeAndMaterialID =
              phaseDetails[j].jobSchedulePhaseForTimeAndMaterialID;
            _employeeObj.worksFor = employeeObj.equipmentCompany;
            workerArray.push({ ..._employeeObj });
          }
        }
        mergedArray = { workerArray };
        this._equipment = { workerArray };
      }
    }

    for (let index = 0; index < crewDetails.length; index++) {
      let tempEquipmentId = crewDetails[index].equipmentId as string;
      if (tempEquipmentId) {
        let workerArray: Array<EmployeePhaseWiseLoggedHours> = [];
        if (mergedArray.workerArray) {
          for (let j = 0; j < mergedArray.workerArray.length; j++) {
            if (
              crewDetails[index].equipmentId ===
              mergedArray.workerArray[j].equipmentId
            ) {
              workerArray.push({ ...mergedArray.workerArray[j] });
            }
          }
        }
        tableArray[tempEquipmentId] = workerArray;
        this.finalEquipmentList = tableArray;
      }
    }

    this.cdr.detectChanges();
  }

  getEmployeeName(id: unknown): Array<CrewDetails> {
    const changeIdType = parseInt(id as string);
    for (let index = 0; index < this.crewDetails.length; index++) {
      if (changeIdType === this.crewDetails[index].employeeId) {
        return [this.crewDetails[index]];
      }
    }
    return [];
  }

  getEquipmentName(id: unknown): Array<CrewDetails> {
    const changeIdType = id as string;
    for (let index = 0; index < this.crewDetails.length; index++) {
      if (changeIdType === this.crewDetails[index].equipmentId) {
        return [this.crewDetails[index]];
      }
    }
    return [];
  }

  getTotalHours(id: unknown): number {
    let totalHours = 0;
    const changeIdType = parseInt(id as string);
    for (let index = 0; index < this._mergedArray.workerArray.length; index++) {
      if (
        changeIdType === this._mergedArray.workerArray[index].employeeId &&
        this._mergedArray.workerArray[index].loggedHours
      ) {
        totalHours =
          totalHours + this._mergedArray.workerArray[index].loggedHours;
      }
    }
    return totalHours;
  }

  getEquipmentTotalHours(id: unknown): number {
    let totalHours = 0;
    const changeIdType = id as string;
    for (let index = 0; index < this._equipment.workerArray.length; index++) {
      if (
        changeIdType === this._equipment.workerArray[index].equipmentId &&
        this._equipment.workerArray[index].loggedHours
      ) {
        totalHours =
          totalHours + this._equipment.workerArray[index].loggedHours;
      }
    }
    return totalHours;
  }

  updateTableChanges(upDateObj: TimeCardUpdateParams): void {
    this.changeEmployeePhase(upDateObj);
    const id = upDateObj.employeeId as number;
    const isTANDM = upDateObj.isTANDM;
    const phaseId = upDateObj.phaseId as string;
    this.findUpdateHours(
      id,
      phaseId,
      this.updateFormArray,
      isTANDM as boolean,
      true
    );
    this.updateFormArray.push(upDateObj);
    const filtered = this.updateFormArray.filter(function (el) {
      return el !== null;
    });
    this.updateFormArray = filtered;
    for (let index = 0; index < this._mergedArray.workerArray.length; index++) {
      if (
        this._mergedArray.workerArray[index].employeeId === id &&
        this._mergedArray.workerArray[index].phaseId === phaseId &&
        this._mergedArray.workerArray[index].isTANDM === isTANDM
      ) {
        this._mergedArray.workerArray[index] = upDateObj;
      }
    }

    this.cdr.detectChanges();
  }

  updateTableEquipmentChanges(upDateObj: TimeCardUpdateParams): void {
    this.changeEmployeePhase(upDateObj);
    const id = upDateObj.equipmentId as string;
    const phaseId = upDateObj.phaseId as string;
    const isTANDM = upDateObj.isTANDM;
    this.findUpdateEquipmentHours(
      id,
      phaseId,
      this.updateFormArray,
      isTANDM as boolean,
      true
    );
    this.updateFormArray.push(upDateObj);
    const filtered = this.updateFormArray.filter((el) => {
      return el !== null;
    });
    this.updateFormArray = filtered;
    for (let index = 0; index < this._equipment.workerArray.length; index++) {
      if (
        this._equipment.workerArray[index].equipmentId === id &&
        this._equipment.workerArray[index].phaseId === phaseId &&
        this._equipment.workerArray[index].isTANDM === isTANDM
      ) {
        this._equipment.workerArray[index] = upDateObj;
      }
    }

    this.cdr.detectChanges();
  }

  findEmployeeName(
    id: number,
    phaseId: string,
    emp: Array<EmployeePhaseWiseLoggedHours>,
    isTANDM: boolean
  ): EmployeePhaseWiseLoggedHours | null {
    for (let index = 0; index < emp.length; index++) {
      if (
        emp[index].employeeId === id &&
        emp[index].phaseId === phaseId &&
        emp[index].isTANDM === isTANDM
      ) {
        return emp[index];
      }
    }
    return null;
  }

  findEquipmentName(
    id: string,
    phaseId: string,
    emp: Array<EmployeePhaseWiseLoggedHours>,
    isTANDM: boolean
  ): EmployeePhaseWiseLoggedHours | null {
    for (let index = 0; index < emp.length; index++) {
      if (
        emp[index].equipmentId === id &&
        emp[index].phaseId === phaseId &&
        emp[index].isTANDM === isTANDM
      ) {
        return emp[index];
      }
    }
    return null;
  }

  findUpdateHours(
    id: number,
    phaseID: string,
    employee: Array<TimeCardUpdateParams>,
    isTANDM: boolean,
    isUpdated?: boolean
  ): boolean {
    if (employee) {
      for (let index = 0; index < employee.length; index++) {
        if (
          employee[index]?.employeeId === id &&
          employee[index].phaseId === phaseID &&
          employee[index].isTANDM === isTANDM
        ) {
          isUpdated ? delete this.updateFormArray[index] : null;
          return true;
        }
      }
    }
    return false;
  }

  findUpdateEquipmentHours(
    id: string,
    phaseID: string,
    employee: Array<TimeCardUpdateParams>,
    isTANDM: boolean,
    isUpdated?: boolean
  ): boolean {
    if (employee) {
      for (let index = 0; index < employee.length; index++) {
        if (
          employee[index]?.equipmentId === id &&
          employee[index].phaseId === phaseID &&
          employee[index].isTANDM === isTANDM
        ) {
          isUpdated ? delete this.updateFormArray[index] : null;
          return true;
        }
      }
    }
    return false;
  }

  isNumber(val: any): boolean {
    return typeof val === 'number';
  }

  saveTableViewChanges(checkFromNext?: number): void {
    this.validArrayCheck();
    this.updateTimecardTable(checkFromNext);
  }

  updateTimecardTable(checkFromNext?: number): void {
    this.unSavedStatus = true;
    if (this.updateFormArray.length && this.formValidStatus) {
      this.timeCardService
        .updateCrewPhaseDetailsByJobScheduleId(
          this.selectedJobScheduleId,
          this.logInUser,
          this.updateFormArray
        )
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (response) => {
            this.toasterService.success(response.message);
            if (checkFromNext) {
              this.goToReview();
            } else {
              this.goToDashboard();
            }
          },
          error: () => {
            this.toasterService.info(this.messages.error.unknownError);
          },
        });
    } else if (!this.updateFormArray.length) {
      if (checkFromNext) {
        this.goToReview();
      } else {
        this.goToDashboard();
      }
    } else {
      this.toasterService.info('please correct error first');
      this.cdr.detectChanges();
    }
  }

  goToDashboard(): void {
    this.goToReview();
  }

  validArrayCheck(): void {
    for (let index = 0; index < this.updateFormArray.length; index++) {
      if (typeof this.updateFormArray[index].loggedHours !== 'number') {
        this.formValidStatus = false;
        this.cdr.detectChanges();
        break;
      } else {
        this.formValidStatus = true;
        this.cdr.detectChanges();
      }
    }
  }

  openEmployeeSidebar(employee: TemplateRef<unknown>): void {
    this.employeeModalRef = this.modalService.showModal(employee, {
      ...this.constants.globalModalConfig,
      ...this.constants.sidebarModalConfig,
    });
  }

  openPhaseSidebar(phase: TemplateRef<unknown>): void {
    this.phaseModalRef = this.modalService.showModal(phase, {
      ...this.constants.globalModalConfig,
      ...this.constants.sidebarModalConfig,
    });
  }

  openEquipmentSidebar(phase: TemplateRef<unknown>): void {
    this.equipmentModalRef = this.modalService.showModal(phase, {
      ...this.constants.globalModalConfig,
      ...this.constants.sidebarModalConfig,
    });
  }

  openInputSidebar(
    phase: TemplateRef<unknown>,
    data: TimeCardUpdateParams,
    activeInput: string
  ): void {
    this.activeInput = activeInput;
    this.userSelectedInput = data;
    this.openCalculator(phase);
  }

  closeSidebar(perDiemState?: number): void {
    if (!perDiemState) {
      this.getCrewPhaseDetailsByJobScheduleId(
        this.selectedJobScheduleId,
        getFormattedDate(this.selectedDate)
      );
    }
  }

  openPerDiemSidebar(
    perDiem: TemplateRef<unknown>,
    crewDetails: CrewDetails
  ): void {
    if (!this.readOnlyApp) {
      this.perDiemModalRef = this.modalService.showModal(perDiem, {
        ...this.constants.globalModalConfig,
        ...this.constants.sidebarSmModalConfig,
      });
      this.passPerDiem = crewDetails as PerDiemData;
    }
  }

  goToReview(): void {
    const id = this.activatedRoute.snapshot.queryParamMap.get('id');
    if (id) {
      if (this.previousUrl) {
        let urlTree = this.router.parseUrl(this.previousUrl);
        urlTree.queryParams['id'] = id;
        this.router.navigateByUrl(urlTree);
      } else {
        let queryParams = this.activatedRoute.snapshot.queryParams;
        if (Array.isArray(queryParams.id)) {
          queryParams.id = queryParams.id[0];
        }
        this.router.navigate(['Review', REVIEW_TABS.EMPLOYEE], {
          queryParams,
        });
      }
    } else {
      let queryParams = this.activatedRoute.snapshot.queryParams;
      if (Array.isArray(queryParams.id)) {
        queryParams.id = queryParams.id[0];
      }
      this.router.navigate(['Review', REVIEW_TABS.EMPLOYEE], {
        queryParams,
      });
    }
  }

  changeEmployeePhase(finalData: TimeCardUpdateParams): void {
    if (!finalData.isTANDM) {
      finalData.jobSchedulePhaseForTimeAndMaterialID = '';
    } else {
      finalData.jobSchedulePhaseID = '';
    }
  }

  getJobScheduleDetails(selectedJobScheduleId: string): void {
    this.foremanService
      .get<ApiResponse<EventTask>>(
        selectedJobScheduleId,
        API_URL_UTIL.foreman.jobSchedule
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (job) => {
          this.readOnlyApp = !job?.data?.isJobInCurrentWeek as boolean;
          this.readOnlyApp = false;
          this.userSelectedEvent = job.data;
          this.statusService.updateStatus(job.data.jobCompleted);
          if (this.selectedJobScheduleId && this.selectedDate) {
            this.getCrewPhaseDetailsByJobScheduleId(
              this.selectedJobScheduleId,
              getFormattedDate(this.selectedDate)
            );
          }
        },
        () => {}
      );
  }

  saveTableOnDestroy(): void {
    this.validArrayCheck();
    this.saveUnsavedStateTable();
  }

  saveConfirmation(popNumber: string, sidebar: TemplateRef<unknown>): void {
    this.sidebar = sidebar;
    this.sidebarString = popNumber;
    if (this.updateFormArray?.length) {
      this.saveTableOnDestroy();
    }
    this.sidebarOpen();
  }

  saveUnsavedStateTable(): void {
    if (this.updateFormArray?.length && this.formValidStatus) {
      this.timeCardService
        .updateCrewPhaseDetailsByJobScheduleId(
          this.selectedJobScheduleId,
          this.logInUser,
          this.updateFormArray
        )
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (response: HttpStatus) => {
            this.toasterService.success(response.message);
            this.statusService.updateSingleStatus('isTimecardCompleted', true);
            this.getCrewPhaseDetailsByJobScheduleId(
              this.selectedJobScheduleId,
              getFormattedDate(this.selectedDate)
            );
            this.updateFormArray = [];
          },
          error: () => {
            this.toasterService.info(this.messages.error.unknownError);
          },
        });
    } else if (this.updateFormArray.length) {
      this.toasterService.info(this.messages.formError.timecardFormError);
    }
  }

  sidebarOpen(): void {
    switch (this.sidebarString) {
      case 'Employee':
        this.openEmployeeSidebar(this.sidebar);
        break;
      case 'Phase':
        this.openPhaseSidebar(this.sidebar);
        break;
      case 'Equipment':
        this.openEquipmentSidebar(this.sidebar);
        break;
      case 'TandM':
        break;
    }
  }
  // todo need conformation form QA
  // isTandM(phaseID: string): boolean {
  //   const check = this.copyOfPhaseDetails.findIndex(phase => {
  //     return phase.phaseID === phaseID && phase.isTANDM
  //   });
  //   return check === -1;
  // }

  addSingleTAndMPhase(phaseID: string, toggleValue: boolean | undefined): void {
    const body = {
      jobScheduleID: this.selectedJobScheduleId,
      phaseID: phaseID,
      convetToTandM: !toggleValue,
    };
    this.timeCardService
      .add<ApiResponse<HttpStatus>, TandMBody>(
        body,
        API_URL_UTIL.foreman.addSingleTAndMPhase
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.toasterService.success(res.message);
        this.getCrewPhaseDetailsByJobScheduleId(
          this.selectedJobScheduleId,
          getFormattedDate(this.selectedDate)
        );
      });
  }

  unSavedSingleTAndMSwitch(
    phaseID: string,
    toggleValue: boolean | undefined
  ): void {
    this.phaseIdSingleTandM = phaseID;
    this.toggleValue = toggleValue as boolean;
    if (this.updateFormArray?.length) {
      this.saveTableOnDestroy();
    }
    this.addSingleTAndMPhase(this.phaseIdSingleTandM, this.toggleValue);
  }

  override ngOnDestroy(): void {
    this.saveTableOnDestroy();
    this.reset();
  }

  closeCalculator(event: number | undefined): void {
    event = event ? event : 0;
    if (typeof event === 'number' && !this.multiMode) {
      this.userSelectedInput.loggedHours = event;
      this.userSelectedInput.isSelected = false;
      switch (this.activeInput) {
        case 'Employee':
          this.updateTableChanges(this.userSelectedInput);
          break;
        case 'Equipment':
          this.updateTableEquipmentChanges(this.userSelectedInput);
          break;
      }
    } else {
      this.processDataEmployee(event);
      this.processDataEquipment(event);
    }
  }

  get isAddPhaseTandMEnabled(): boolean {
    let _isAddPhaseTandMEnabled = true;
    switch (this.positionCode) {
      case this.constants.roles.foreman:
        _isAddPhaseTandMEnabled = true;
        break;
      case this.constants.roles.ShopSupervisor:
        // _isAddPhaseTandMEnabled = false;
        break;
      case this.constants.roles.labour:
        break;
      case this.constants.roles.mechanic:
        break;
      case this.constants.roles.shopAssist:
        // _isAddPhaseTandMEnabled = true;
        break;
    }
    return _isAddPhaseTandMEnabled;
  }

  openSideBar(
    phase: TemplateRef<unknown>,
    data: TimeCardUpdateParams,
    activeInput: string
  ): void {
    if (!this.readOnlyApp) {
      if (this.multiMode) {
        if (data.employeeId !== 0) {
          const id = data.employeeId;
          const index = this.employeeData.findIndex(
            (localData) =>
              localData.employeeId === id &&
              localData.phaseId === data.phaseId &&
              localData.isTANDM === data.isTANDM
          );
          if (index === -1) {
            this.employeeData.push(data);
          } else {
            delete this.employeeData[index];
            const filtered = this.employeeData.filter(function (el) {
              return el !== null;
            });
            this.employeeData = filtered;
          }
        } else if (data.equipmentId !== '') {
          const id = data.equipmentId;
          const index = this.equipmentData.findIndex(
            (localData) =>
              localData.equipmentId === id &&
              localData.phaseId === data.phaseId &&
              localData.isTANDM === data.isTANDM
          );
          if (index === -1) {
            this.equipmentData.push(data);
          } else {
            delete this.equipmentData[index];
            const filtered = this.equipmentData.filter(function (el) {
              return el !== null;
            });
            this.equipmentData = filtered;
          }
        }
        this.selectedInput =
          this.employeeData.length + this.equipmentData.length;
      } else {
        this.openInputSidebar(phase, data, activeInput);
      }
    }
  }

  processDataEmployee(userSelectedInput: number | undefined): void {
    if (typeof userSelectedInput === 'number') {
      for (const iterator of this.employeeData) {
        iterator.loggedHours = userSelectedInput;
        iterator.isSelected = false;
        this.updateTableChanges(iterator);
      }
      this.cdr.detectChanges();
    }
  }

  processDataEquipment(userSelectedInput: number | undefined): void {
    if (typeof userSelectedInput === 'number') {
      for (const iterator of this.equipmentData) {
        iterator.loggedHours = userSelectedInput;
        iterator.isSelected = false;
        this.updateTableEquipmentChanges(iterator);
      }
    }
    this.reset();
  }

  openCalculator(phase: TemplateRef<unknown>): void {
    if (!this.readOnlyApp) {
      this.inputModalRef = this.modalService.showModal(phase, {
        ...this.constants.globalModalConfig,
        ...this.constants.calculatorModalConfig,
      });
      this.cdr.detectChanges();
    }
  }

  reset(): void {
    this.employeeData = [];
    this.equipmentData = [];
    this.selectedInput = 0;
    this.cdr.detectChanges();
  }
}
